import { Store } from '@ngxs/store';
import { DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import moment from 'moment';
import { LocalizationState } from '@nimbus-library/features/localization/store/localization.state';

// The moment adapter takes the first day of the week from moment's global locale, which other code changes as a side effect.
// Week bounds follow the user's date format instead, like the labels in NimbusCalendarDateFormatter.
export function calendarDateAdapterFactory(store: Store): DateAdapter {
  const userMoment = (date: Date | number): moment.Moment =>
    moment(date).locale(store.selectSnapshot(LocalizationState.selectedDateFormat) ?? moment.locale());

  return Object.assign(adapterFactory(moment), {
    startOfWeek: (date: Date | number): Date => userMoment(date).startOf('week').toDate(),
    endOfWeek: (date: Date | number): Date => userMoment(date).endOf('week').toDate(),
  });
}
